import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { getCollectionCollaboratorsListService } from 'src/api/collection'
import { getCollectionCollaboratorsListSuccess } from 'src/reducers/collection/action'
import { GET_COLLECTION_COLLABORATORS_LIST } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionCollaboratorsListFlow(payload) {
  try {
    const { id, query, callback } = payload

    const response = yield call(
      getCollectionCollaboratorsListService,
      id,
      query,
    )

    yield put(getCollectionCollaboratorsListSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionCollaboratorsListWatcher() {
  while (true) {
    const action = yield takeMaybe(GET_COLLECTION_COLLABORATORS_LIST)
    const { payload } = action

    yield fork(generalSaga, collectionCollaboratorsListFlow, payload)
  }
}
